(function() {
    const DEBUG_MODE = false; // Set to false for production
    let isUpdating = false;
    let debounceTimer = null;

    function logDebug(...args) {
        if (DEBUG_MODE) {
            console.log('[LGX Gift Message]', ...args);
        }
    }

    function logError(...args) {
        console.error('[LGX Gift Message]', ...args);
    }

    function debounce(func, wait) {
        return function executedFunction(...args) {
            const later = () => {
                clearTimeout(debounceTimer);
                func(...args);
            };
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(later, wait);
        };
    }

    async function getCurrentCart() {
        try {
            const response = await fetch(`${Shopify.routes.root}cart.js`);
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            const cart = await response.json();
            logDebug('Fetched current cart:', cart);
            return cart;
        } catch (error) {
            logError('Failed to fetch cart:', error);
            return null;
        }
    }

    function updateWrapperItemKey(variantId) {
        // Handle both cart drawer and main cart containers
        const containers = document.querySelectorAll('.lgx-gift-message-wrapper, .lgx-gift-message-container');
        if (containers.length === 0) return;

        getCurrentCart().then(cart => {
            if (cart) {
                const giftItem = cart.items.find(item => 
                    item.variant_id === parseInt(variantId) && 
                    item.properties && 
                    item.properties['Gift Message']
                );
                
                containers.forEach(container => {
                    if (giftItem) {
                        container.setAttribute('data-lgx-gift-message-item-key', giftItem.key);
                        logDebug('Updated container with item key:', giftItem.key);
                    } else {
                        container.setAttribute('data-lgx-gift-message-item-key', '');
                        logDebug('No gift item found, cleared item key');
                    }
                });
            }
        });
    }

    async function addGiftMessageItem(variantId, message) {
        if (isUpdating) {
            logDebug('Already updating, skipping add operation');
            return;
        }

        isUpdating = true;
        logDebug('Adding gift message item:', variantId, 'with message:', message);

        try {
            // First check if gift message item already exists
            const cart = await getCurrentCart();
            if (cart) {
                const existingGiftItem = cart.items.find(item => 
                    item.variant_id === parseInt(variantId) && 
                    item.properties && 
                    item.properties['_gift_message']
                );
                
                if (existingGiftItem) {
                    logDebug('Gift message item already exists, updating instead');
                    isUpdating = false; // Reset flag before calling update
                    await updateGiftMessageItem(existingGiftItem.key, message);
                    return;
                }
            }

            // Start loading state like theme does
            document.dispatchEvent(new CustomEvent('theme:loading:doing', { bubbles: true }));

            // Dispatch cart:push:section.id event to let sections register for updates
            const sectionsEvent = new CustomEvent('cart:push:section.id', {
                bubbles: true,
                detail: { sections: [] }
            });
            document.dispatchEvent(sectionsEvent);
            
            const sectionsToRequest = sectionsEvent.detail.sections;

            const requestBody = {
                items: [{
                    id: variantId,
                    quantity: 1,
                    properties: {
                        'Gift Message': message,
                        '_gift_message': 'true'
                    }
                }]
            };

            if (sectionsToRequest.length > 0) {
                requestBody.sections = sectionsToRequest;
                requestBody.sections_url = window.location.pathname;
            }

            const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(requestBody)
            });

            const result = await response.json();
            
            // End loading state like theme does
            document.dispatchEvent(new CustomEvent('theme:loading:done', { bubbles: true }));
            
            if (!response.ok) {
                logError('Failed to add gift message item:', result);
                return null;
            }

            logDebug('Successfully added gift message item:', result);
            
            // Update the wrapper with the new item key
            updateWrapperItemKey(variantId);
            
            // Get fresh cart data and dispatch cart change event like theme does
            const updatedCart = await getCurrentCart();
            updatedCart.sections = result.sections; // Attach sections from API response
            
            document.dispatchEvent(new CustomEvent('cart:change', {
                bubbles: true,
                detail: {
                    cart: updatedCart,
                    baseEvent: 'cart:gift_message:add',
                    request_url: window.location.pathname,
                    source: 'lgx-gift-message'
                }
            }));

            return result;
        } catch (error) {
            logError('Error adding gift message item:', error);
            // End loading state on error
            document.dispatchEvent(new CustomEvent('theme:loading:done', { bubbles: true }));
            return null;
        } finally {
            setTimeout(() => {
                isUpdating = false;
                logDebug('Add operation complete, flag reset');
            }, 500);
        }
    }

    async function updateGiftMessageItem(itemKey, message) {
        if (isUpdating) {
            logDebug('Already updating, skipping update operation');
            return;
        }

        isUpdating = true;
        logDebug('Updating gift message item:', itemKey, 'with message:', message);

        try {
            // Start loading state like theme does
            document.dispatchEvent(new CustomEvent('theme:loading:doing', { bubbles: true }));

            // Dispatch cart:push:section.id event to let sections register for updates
            const sectionsEvent = new CustomEvent('cart:push:section.id', {
                bubbles: true,
                detail: { sections: [] }
            });
            document.dispatchEvent(sectionsEvent);
            
            const sectionsToRequest = sectionsEvent.detail.sections;

            if (message.trim() === '') {
                // Remove item if message is empty - use cart/update.js like cart sync
                const requestBody = {
                    updates: { [itemKey]: 0 }
                };

                if (sectionsToRequest.length > 0) {
                    requestBody.sections = sectionsToRequest;
                    requestBody.sections_url = window.location.pathname;
                }

                const response = await fetch(`${Shopify.routes.root}cart/update.js`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(requestBody)
                });

                const result = await response.json();
                
                // End loading state like theme does
                document.dispatchEvent(new CustomEvent('theme:loading:done', { bubbles: true }));
                
                if (!response.ok) {
                    logError('Failed to remove gift message item:', result);
                    return;
                }

                logDebug('Successfully removed gift message item:', result);
                
                                        // Clear the container item keys
                        const containers = document.querySelectorAll('.lgx-gift-message-wrapper, .lgx-gift-message-container');
                        containers.forEach(container => {
                            container.setAttribute('data-lgx-gift-message-item-key', '');
                        });
                
                // Dispatch cart change event like theme does
                document.dispatchEvent(new CustomEvent('cart:change', {
                    bubbles: true,
                    detail: {
                        cart: result,
                        baseEvent: 'cart:gift_message:remove',
                        request_url: window.location.pathname,
                        source: 'lgx-gift-message'
                    }
                }));
            } else {
                // For updating properties, we need to use a different approach
                // First, get current cart to get variant ID
                const cart = await getCurrentCart();
                if (cart) {
                    const giftItem = cart.items.find(item => item.key === itemKey);
                    if (giftItem) {
                        // Remove the old item and add a new one with updated properties
                        // This is a two-step process but ensures properties are updated correctly
                        
                        // Step 1: Remove the old item
                        const removeBody = {
                            updates: { [itemKey]: 0 }
                        };

                        const removeResponse = await fetch(`${Shopify.routes.root}cart/update.js`, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify(removeBody)
                        });

                        if (!removeResponse.ok) {
                            const removeResult = await removeResponse.json();
                            logError('Failed to remove old gift message item for update:', removeResult);
                            // End loading state on error
                            document.dispatchEvent(new CustomEvent('theme:loading:done', { bubbles: true }));
                            return;
                        }

                        // Step 2: Add new item with updated properties
                        const addBody = {
                            items: [{
                                id: giftItem.variant_id,
                                quantity: 1,
                                properties: {
                                    'Gift Message': message,
                                    '_gift_message': 'true'
                                }
                            }]
                        };

                        if (sectionsToRequest.length > 0) {
                            addBody.sections = sectionsToRequest;
                            addBody.sections_url = window.location.pathname;
                        }

                        const addResponse = await fetch(`${Shopify.routes.root}cart/add.js`, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify(addBody)
                        });

                        const addResult = await addResponse.json();
                        
                        // End loading state like theme does
                        document.dispatchEvent(new CustomEvent('theme:loading:done', { bubbles: true }));
                        
                        if (!addResponse.ok) {
                            logError('Failed to add updated gift message item:', addResult);
                            return;
                        }

                        logDebug('Successfully updated gift message item properties:', addResult);
                        
                        // Update wrapper with new item key
                        updateWrapperItemKey(giftItem.variant_id);
                        
                        // Get fresh cart data and dispatch cart change event like theme does
                        const updatedCart = await getCurrentCart();
                        updatedCart.sections = addResult.sections; // Attach sections from API response
                        
                        document.dispatchEvent(new CustomEvent('cart:change', {
                            bubbles: true,
                            detail: {
                                cart: updatedCart,
                                baseEvent: 'cart:gift_message:update',
                                request_url: window.location.pathname,
                                source: 'lgx-gift-message'
                            }
                        }));
                    } else {
                        // End loading state if item not found
                        document.dispatchEvent(new CustomEvent('theme:loading:done', { bubbles: true }));
                    }
                } else {
                    // End loading state if cart fetch failed
                    document.dispatchEvent(new CustomEvent('theme:loading:done', { bubbles: true }));
                }
            }

        } catch (error) {
            logError('Error updating gift message item:', error);
            // End loading state on error
            document.dispatchEvent(new CustomEvent('theme:loading:done', { bubbles: true }));
        } finally {
            setTimeout(() => {
                isUpdating = false;
                logDebug('Update operation complete, flag reset');
            }, 500);
        }
    }

    function handleGiftMessageChange(container, textarea) {
        const message = textarea.value;
        const variantId = container.getAttribute('data-lgx-gift-message-variant') || container.dataset.giftMessageVariantId;
        const currentItemKey = container.getAttribute('data-lgx-gift-message-item-key') || container.dataset.giftMessageItemKey;

        logDebug('Gift message changed:', message, 'Variant ID:', variantId, 'Current item key:', currentItemKey);

        if (message.trim() === '') {
            // Empty message - remove item if it exists
            if (currentItemKey && currentItemKey !== '') {
                updateGiftMessageItem(currentItemKey, '');
            }
        } else {
            // Has message
            if (currentItemKey && currentItemKey !== '') {
                // Update existing item
                updateGiftMessageItem(currentItemKey, message);
            } else {
                // Add new item
                addGiftMessageItem(variantId, message);
            }
        }
    }

    function initializeGiftMessage() {
        // Handle both cart drawer and main cart gift message containers
        const containers = document.querySelectorAll('.lgx-gift-message-wrapper, .lgx-gift-message-container');
        if (containers.length === 0) {
            logDebug('No gift message containers found');
            return;
        }

        containers.forEach(container => {
            // Find textarea within this container
            const textarea = container.querySelector('#lgx-gift-message, #lgx-gift-message-main-cart, [data-lgx-gift-message-input]');
            if (!textarea) {
                logDebug('No gift message textarea found in container');
                return;
            }

            logDebug('Initializing gift message system for container');

            // Create debounced handler for this specific container/textarea pair
            const debouncedHandler = debounce(() => {
                handleGiftMessageChange(container, textarea);
            }, 3000); // 3 second delay like original system

            // Add event listeners
            textarea.addEventListener('input', debouncedHandler);
            textarea.addEventListener('blur', () => {
                // Handle immediately on blur (when user clicks away)
                clearTimeout(debounceTimer);
                handleGiftMessageChange(container, textarea);
            });
        });

        // Sync with current cart state
        syncWithCart();
    }

    async function syncWithCart() {
        const containers = document.querySelectorAll('.lgx-gift-message-wrapper, .lgx-gift-message-container');
        if (containers.length === 0) return;

        try {
            const cart = await getCurrentCart();
            if (!cart) return;

            containers.forEach(container => {
                const textarea = container.querySelector('#lgx-gift-message, #lgx-gift-message-main-cart, [data-lgx-gift-message-input]');
                if (!textarea) return;

                const variantId = parseInt(container.getAttribute('data-lgx-gift-message-variant') || container.dataset.giftMessageVariantId);
                if (!variantId) return;

                // Find gift message item
                const giftItem = cart.items.find(item => 
                    item.variant_id === variantId && 
                    item.properties && 
                    item.properties['_gift_message']
                );

                if (giftItem) {
                    // Update container with current item key
                    container.setAttribute('data-lgx-gift-message-item-key', giftItem.key);
                    
                    // Update textarea with current message
                    const currentMessage = giftItem.properties['Gift Message'] || '';
                    if (textarea.value !== currentMessage) {
                        textarea.value = currentMessage;
                        textarea.dataset.currentMessage = currentMessage;
                    }
                    
                    logDebug('Synced with existing gift item:', giftItem);
                } else {
                    // No gift item found, clear the key
                    container.setAttribute('data-lgx-gift-message-item-key', '');
                    
                    // Clear textarea if it has content but no corresponding cart item
                    if (textarea.value.trim() !== '') {
                        textarea.value = '';
                        textarea.dataset.currentMessage = '';
                    }
                    
                    logDebug('No gift item found in cart');
                }
            });
        } catch (error) {
            logError('Error syncing with cart:', error);
        }
    }

    // Listen for cart changes from other sources
    document.addEventListener('cart:change', function(event) {
        logDebug('Cart change detected, source:', event.detail?.source, 'baseEvent:', event.detail?.baseEvent);
        
        // Don't sync if the change came from this script
        if (event.detail?.source === 'lgx-gift-message') {
            logDebug('Skipping sync - change originated from gift message script');
            return;
        }

        // Sync after a short delay to ensure DOM is updated
        setTimeout(syncWithCart, 100);
    });

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initializeGiftMessage);
    } else {
        initializeGiftMessage();
    }

    // Re-initialize when cart drawer or cart page updates (for section re-renders)
    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.type === 'childList') {
                const addedNodes = Array.from(mutation.addedNodes);
                const hasGiftMessage = addedNodes.some(node => 
                    node.nodeType === Node.ELEMENT_NODE && 
                    node.querySelector && 
                    (node.querySelector('.lgx-gift-message-wrapper') || node.querySelector('.lgx-gift-message-container'))
                );
                
                if (hasGiftMessage) {
                    logDebug('Gift message element detected in DOM update, re-initializing');
                    setTimeout(initializeGiftMessage, 100);
                }
            }
        });
    });

    // Observe cart drawer for changes
    const cartDrawer = document.querySelector('hdt-cart-drawer');
    if (cartDrawer) {
        observer.observe(cartDrawer, {
            childList: true,
            subtree: true
        });
    }

    // Observe cart page for changes
    const cartPage = document.querySelector('#hdt-page-cart');
    if (cartPage) {
        observer.observe(cartPage, {
            childList: true,
            subtree: true
        });
    }

    logDebug('LGX Gift Message script loaded');
})();
